// src/app/services/upcoming-payments.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { getUpcomingPaymentsUrl, getPendingPaymentsUrl } from '../shared/utils/api-urls.utils';

export interface UpcomingPayment {
  paymentNumber: number;
  dueDate:       Date | null;
  amount:        number;
}

export interface PendingPayment {
  rowId:       number;
  description: string;
  billingType: number;
  inputDate:   Date | null;
  startDate:   Date | null;
  expireDate:  Date | null;
  nextDate:    Date | null;
  amountFixed: number;
  loanNumber:  string;
  notes: string; // <-- add this
}

@Injectable({ providedIn: 'root' })
export class UpcomingPaymentsService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private getAuthHeaders() {
    const token = this.auth.token;
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    };
  }

  getForLoan(loan: string): Observable<UpcomingPayment[]> {
    return this.http
      .get<any[]>(getUpcomingPaymentsUrl(loan), this.getAuthHeaders())
      .pipe(
        map(rawArray =>
          rawArray.map(r => ({
            paymentNumber: r.payment_number,
            dueDate:       r.date_due ? new Date(r.date_due) : null,
            amount:        r.payment_amount,
          })),
        ),
      );
  }

  getPendingForLoan(loan: string): Observable<PendingPayment[]> {
    return this.http
      .get<any[]>(getPendingPaymentsUrl(loan), this.getAuthHeaders())
      .pipe(
        map(rawArray =>
          rawArray.map(r => ({
            rowId:       r.row_id,
            description: r.description,
            billingType: r.billing_type,
            inputDate:   r.input_date    ? new Date(r.input_date)    : null,
            startDate:   r.start_date    ? new Date(r.start_date)    : null,
            expireDate:  r.expire_date   ? new Date(r.expire_date)   : null,
            nextDate:    r.billing_next_date ? new Date(r.billing_next_date) : null,
            amountFixed: r.amount_fixed,
            loanNumber:  r.loan_number,
            notes: r.notes // <-- add this
          })),
        ),
      );
  }
}
